/**
 * Modal — componente reutilizável do ERP.
 * Classes com prefixo `erp-modal` para não colidir com outros `.modal-content` do projeto.
 */

import { useEffect } from 'react'
import './Modal.css'

function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  children,
  size = 'medium',
  footer,
  className = '',
  showCloseButton = true,
  closeOnOverlayClick = true
}) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="erp-modal-overlay"
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div
        className={`erp-modal erp-modal--${size}${className ? ` ${className}` : ''}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'erp-modal-title' : undefined}
      >
        <div className="erp-modal__header">
          <div className="erp-modal__header-content">
            {icon && <div className="erp-modal__icon">{icon}</div>}
            <div className="erp-modal__header-text">
              {title && <h2 id="erp-modal-title" className="erp-modal__title">{title}</h2>}
              {subtitle && <p className="erp-modal__subtitle">{subtitle}</p>}
            </div>
          </div>
          {showCloseButton && (
            <button
              type="button"
              className="erp-modal__close"
              onClick={onClose}
              aria-label="Fechar modal"
            >
              ×
            </button>
          )}
        </div>

        <div className="erp-modal__body">
          {children}
        </div>

        {footer && (
          <div className="erp-modal__footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}

export default Modal
